import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { UPGRADE_PATHS } from "@circle-react-shared/UpgradePlan/constants";
import { Loader } from "./Loader";

const i18nRoot = "pricing_plans.upgrade_modal";
export const EmailHubSubscriptionCheck = () => {
  const { currentPlan, refetchCurrentPlan } = useCurrentPlanApi();
  const history = useHistory();

  const isEmailHubEnabled =
    currentPlan?.email_hub_billing?.email_hub_billing_active;

  useEffect(() => {
    const intervalId = setInterval(() => {
      void refetchCurrentPlan();
    }, 1000);
    return () => clearInterval(intervalId);
  }, [refetchCurrentPlan]);

  useEffect(() => {
    if (isEmailHubEnabled) {
      history.push(UPGRADE_PATHS.UPGRADE_SUCCESSFUL);
    }
  }, [isEmailHubEnabled, history]);

  return (
    <Loader
      title={t([i18nRoot, "loading.creating_email_hub_subscription"])}
      subtitle={t("pricing_plans.upgrade_modal.updating_plan_description")}
    />
  );
};
